export const triggerAnalyticsCustomEvent = (eventName, payload) => {
  window.LIFE_CYCLE_EVENT_BUS.trigger(eventName, payload);
};